import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';
import { consts as removeUserCommunityConsts } from './removeUserCommunity';
import { COMMUNITIES_USER_ROLES } from '../../constants';

const supportedActions = ['LOAD_MEMBERS', 'LOAD_OLDER_MEMBERS', 'CLEAR'];

export const consts = createConsts(
  'communities',
  'membersList',
  ...supportedActions,
);

export const actions = createActions(consts);

const reducer = (state = [], action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.LOAD_OLDER_MEMBERS:
      return [...state, ...payload];
    case consts.LOAD_MEMBERS:
      return payload;
    case consts.CLEAR:
      return [];
    case removeUserCommunityConsts.SEND:
      if (payload.userType === COMMUNITIES_USER_ROLES.MEMBER) {
        return state.filter(item => item.id !== payload.memberId);
      }
      return state;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/communities/membersList.js